module.exports = __webpack_public_path__ + "static/undraw_code_review_l1q9-9c94b1df16fc97e9297d4514be2c1cca.svg";